import type { Meta, StoryFn } from '@storybook/react';

import { HTML } from '@pega/cosmos-react-core';
import type { HTMLProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/HTML',
  component: HTML
} as Meta;

export const HTMLDemo: StoryFn<HTMLProps> = (args: HTMLProps) => <HTML content={args.content} />;

HTMLDemo.args = {
  content:
    '<div><p>Hello, World!<p><ul><li>List item 1<ul><li>Sub list item 1</li></ul></li><li>List item 2</li></ul></div>'
};

HTMLDemo.argTypes = {
  content: { control: { type: 'text' } }
};
